function addListeners(popUpCtaClass){
    const popUpCta = document.querySelectorAll(popUpCtaClass);
    var openedPopUp = null

    popUpCta.forEach(function(cta, index){
        cta.addEventListener("click", (e) => {
            var popUpEl = document.getElementById(`popup-wrapper-${index}`);
            var closePopUpX = document.getElementById(`close-popup-${index}`);
            
            if(openedPopUp && openedPopUp != popUpEl){
                closePopUp(openedPopUp);
            }
            PopUpXClicked(closePopUpX, popUpEl);
            
            openedPopUp = popUpEl;
            togglePopUp(popUpEl);
            
        });
    });
}

function PopUpXClicked(closePopUpX, popUpEl){
    closePopUpX.addEventListener("click", function(){closePopUp(popUpEl)});
}

function togglePopUp(target){ 
    target.classList.toggle("hidden-modal");
}

function closePopUp(openedPopUp){
    openedPopUp.classList.add("hidden-modal");
    openedPopUp = null;
}

function isPopUpOpen(target){
    target.classList.contains("hidden-modal") ? closePopUp(target) : openPopUp(target)
}